import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  activateDeactivateNewsAPI,
  activateDeactivateNewsDataAPI,
  addNewsAPI,
  addNewsDataAPI,
  deleteNewsAPI,
  deleteNewsDataAPI,
  getNewsAPI,
  getNewsDataAPI,
  getTableColumnNames,
  updateNewsAPI,
  updateNewsDataAPI
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch News Table Column Names
export const fetchNewsTableColumnNames = createAsyncThunk(
  "news/fetchNewsTableColumnNames",
  async (news, thunkAPI) => {
    try {
      const response = await getTableColumnNames(news);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error || "Something went wrong");
    }
  }
);

// Fetch News
export const fetchNews = createAsyncThunk(
  "News/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getNewsAPI();
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching news");
    }
  }
);

// Add News
export const addNews = createAsyncThunk(
  "News/add",
  async (news, { rejectWithValue }) => {
    try {
      const response = await addNewsAPI(news);
        toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error adding news");
    }
  }
);

// Update News
export const updateNews = createAsyncThunk(
  "news/update",
  async (news, { rejectWithValue }) => {
    try {
      const response = await updateNewsAPI(news);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error updating news");
    }
  }
);

// Delete News
export const deleteNews = createAsyncThunk(
  "news/delete",
  async (news, { rejectWithValue }) => {
    try {
      const response = await deleteNewsAPI(news);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error deleting news");
    }
  }
);

// Active Deactive News
export const activateDeactivateNews = createAsyncThunk(
  "news/activateDeactivate",
  async (news, { rejectWithValue }) => {
    try {
      const response = await activateDeactivateNewsAPI(news);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error activating/deactivating news");
    }
  }
);

// Fetch News Data
export const fetchNewsData = createAsyncThunk(
  "newsData/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getNewsDataAPI();
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error fetching news data");
    }
  }
);

// Add News Data
export const addNewsData = createAsyncThunk(
  "newsData/add",
  async (newsData, { rejectWithValue }) => {
    try {
      const response = await addNewsDataAPI(newsData);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error adding news data");
    }
  }
);

// Update News Data
export const updateNewsData = createAsyncThunk(
  "newsData/update", 
  async (newsData, { rejectWithValue }) => {
    try {
      const response = await updateNewsDataAPI(newsData);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error updating news data");
    }
  }
);  

// Delete News Data
export const deleteNewsData = createAsyncThunk(
  "newsData/delete", 
  async (newsData, { rejectWithValue }) => {
    try {
      const response = await deleteNewsDataAPI(newsData);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error deleting news data");
    }
  }
);

// Active Deactive News Data
export const activateDeactivateNewsData = createAsyncThunk(
  "newsData/activateDeactivate", 
  async (newsData, { rejectWithValue }) => {
    try {
      const response = await activateDeactivateNewsDataAPI(newsData);
      toast.success(t(response.message));
      return response.data;
    } catch (error) {
      return rejectWithValue(error || "Error activating/deactivating news data");
    }
  }
);
